import Yaktrek from '../assets/yaktrek.jpg';

const YakTrekSection = () => {
  return (
    <section className="w-full max-w-[1920px] mx-auto relative bg-white">
      <div className="relative w-full">
        <img
          src={Yaktrek}
          alt="Yak Trek in Snow"
          className="w-full h-auto object-cover block"
        />

        <div className="absolute bottom-[8%] sm:bottom-[12%] md:bottom-[15%] lg:bottom-[18%] xl:bottom-[230px]
                        left-0 w-full flex flex-col items-center justify-end px-4 text-center">
          <p
            className="font-normal leading-none tracking-[0] text-center drop-shadow-sm"
            style={{
              fontFamily: "'Sustainability', sans-serif",
              fontSize: "clamp(16px, 1.875vw, 36px)",
              fontWeight: 400,
            }}
          >
            Gifted by nature, Created by Bodios
          </p>
        </div>
      </div>
    </section>
  );
};

export default YakTrekSection;